export class LogoWatermark {
  private el: HTMLImageElement;
  constructor(parent: HTMLElement) {
    this.el = document.createElement('img');
    this.el.className = 'logo-wm';
    this.el.alt = '';
    parent.append(this.el);
    this.hide();
  }
  setUrl(url: string): void { this.el.src = url; this.el.style.display = ''; }
  hide(): void { this.el.style.display = 'none'; }
}
